import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import { PMSmallTable } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";

export function addProjectTeamCard(
  view: View<TestAppState, DragAndDropLayout>
): void {
  const teamComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "projectTeamComponent",
      title: "",
      description: "",
      labels: ["team"],
    },
  });

  teamComponent.mapLayoutProps(({ language }) => ({
    componentId: "projectTeamComponent",
    labels: ["team"],
    title: getLocalizedMessage(language || "en", "projectTeam"),
    description: getLocalizedMessage(language || "en", "showsProjectTeam"),
  }));

  teamComponent.mapState(({ settings, language }) => {
    return {
      title:
        getLocalizedMessage(language || "en", "programTeam") || "Program Team",
      icon: "InfoOutlined",
      items: [
        {
          label:
            getLocalizedMessage(language || "en", "programOwner") ||
            "Program Owner",
          value: settings?.configuration?.programOwner ?? "",
          chipColor: theme.palette.secondary.main,
          chipTextColor: theme.palette.primary.main,
          cutValueAfter: 20,
        },
      ],
      fixedHeight: "134px",
    };
  });
}
